import { Inject, Injectable, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfigService } from '../../shared/appconfig/appconfig.service'

import { UserAlert } from '../../shared/models/core.model';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
  }

  getActive() {

    return this.http.get<UserAlert[]>(AppConfigService.settings.get('chatstyleapiServer') + 'alerts/active');

  }

  getLast(count) {

    return this.http.get<UserAlert[]>(AppConfigService.settings.get('chatstyleapiServer') + 'alerts/last/' + count);

  }

  getAll() {

    return this.http.get<UserAlert[]>(AppConfigService.settings.get('chatstyleapiServer') + 'alerts/active');

  }


  resolveAll() {
    return this.http.put(AppConfigService.settings.get('chatstyleapiServer') + 'alerts/resolve-all', {});
  }

  testNotification() {
    return this.http.put(AppConfigService.settings.get('chatstyleapiServer') + 'alerts/test-notification', {});
  }

}


